export const activeBackground = "#c3621d";
export const activeBorder = "thin solid #f95a28";
export const inactiveBackground = "cadetblue";
export const inactiveBorder = "thin solid #457173";